import React, { useContext, useEffect, useMemo, useState } from "react";
import instance from "../axios/global";
import { useNavigate } from "react-router-dom";
import edit from "../assets/Edit.svg";
import trash from "../assets/Trash-2.svg";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import LoaderComp from "../components/LoaderComp";
import { Modal, Select } from "@mantine/core";
import NavBdc from "../components/NavBdc";
import { useParams } from "react-router-dom";
import { AuthContext } from "../auth/auth";
import Papa from "papaparse";

const FixBdc = () => {
  const { id } = useParams();
  const [userBdcList, setUserBdcList] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [opened, setOpened] = useState(false);
  const navigate = useNavigate();
  const [idBdc, setIdBdc] = useState("");
  const [filtres, setFiltres] = useState({
    sortColumn: "number",
    sortDirection: "desc",
    status: "",
  });
  const { authState } = useContext(AuthContext);
  const [sortDirection, setSortDirection] = useState("desc");
  const [statutFilter, setStatutFilter] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [optionsType, setOptionsType] = useState([]);
  const [typeFilter, setTypeFilter] = useState("");
  const [page, setPage] = useState(1);
  const pageSize = 50;
  const [totalRowsFromApi, setTotalRowsFromApi] = useState(0);
  const [totalPagesFromApi, setTotalPagesFromApi] = useState(1);
  const [isServerPaginated, setIsServerPaginated] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchQuery.trim());
    }, 300);

    return () => clearTimeout(timer);
  }, [searchQuery]);

  useEffect(() => {
    setPage(1);
  }, [
    debouncedSearch,
    statutFilter,
    typeFilter,
    filtres.sortColumn,
    filtres.sortDirection,
  ]);

  const handleRightClick = (event, bdcId) => {
    const cmdOrCtrlPressed = event.metaKey || event.ctrlKey;
    if (cmdOrCtrlPressed) {
      event.preventDefault();
      const url = `/bdc/update/${bdcId}`;
      const newTab = window.open(url, "_blank", "noopener,noreferrer");
      if (newTab) {
        newTab.opener = window;
      }
    }
  };

  useEffect(() => {
    const fetchOptionType = async () => {
      setLoading(true);
      try {
        const res = await instance.get("/bdc/alltype");
        setOptionsType(res.data || []);
      } catch (error) {
        console.log("error", error);
      } finally {
        setLoading(false);
      }
    };
    fetchOptionType();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const fetchBdc = async () => {
      setLoading(true);
      try {
        const res = await instance.get(`/bdc/noupdate/${id}`, {
          params: {
            page,
            limit: pageSize,
            search: debouncedSearch || undefined,
            status: statutFilter || undefined,
            type: typeFilter || undefined,
            sortBy: filtres.sortColumn || undefined,
            sortDirection: filtres.sortDirection || undefined,
          },
        });

        const payload = res?.data || {};
        const rows = Array.isArray(payload)
          ? payload
          : payload.items || payload.bdcs || payload.data || [];
        const total = payload.total || payload.totalCount || rows.length;
        const totalPages =
          payload.totalPages || Math.max(1, Math.ceil(total / pageSize));

        setUserBdcList(rows);
        setTotalRowsFromApi(total);
        setTotalPagesFromApi(totalPages);
        setIsServerPaginated(
          payload.page !== undefined ||
            payload.total !== undefined ||
            payload.totalPages !== undefined ||
            payload.items !== undefined
        );
      } catch (error) {
        console.log("error", error);
      } finally {
        setLoading(false);
      }
    };
    fetchBdc();
  }, [id, page, debouncedSearch, statutFilter, typeFilter, filtres]);

  const filteredBdcList = useMemo(() => {
    return userBdcList.filter((element) => {
      const statusFilterMatch =
        statutFilter === "" ||
        (statutFilter === "TA" && element.totalAttribution === 100) ||
        (statutFilter === "NA" && element.totalAttribution === 0) ||
        (statutFilter === "PA" &&
          element.totalAttribution > 0 &&
          element.totalAttribution < 100);

      const typeFilterMatch =
        typeFilter === "" || element.main_expertise === typeFilter;

      const searchLower = debouncedSearch.toLowerCase();
      const searchMatch =
        !searchLower ||
        element?.number?.toString().toLowerCase().includes(searchLower) ||
        element?.name?.toLowerCase().includes(searchLower) ||
        element?.client_name?.toLowerCase().includes(searchLower);

      return statusFilterMatch && typeFilterMatch && searchMatch;
    });
  }, [userBdcList, debouncedSearch, statutFilter, typeFilter]);

  const sortedBdcList = useMemo(
    () =>
      [...filteredBdcList].sort((a, b) => {
        const { sortColumn, sortDirection: currentDirection } = filtres;
        if (currentDirection === "asc") {
          return a[sortColumn] < b[sortColumn] ? -1 : 1;
        }
        return a[sortColumn] > b[sortColumn] ? -1 : 1;
      }),
    [filteredBdcList, filtres]
  );

  const displayedBdcRows = isServerPaginated
    ? sortedBdcList
    : sortedBdcList.slice((page - 1) * pageSize, page * pageSize);

  const totalRows = isServerPaginated ? totalRowsFromApi : sortedBdcList.length;
  const totalPages = isServerPaginated
    ? totalPagesFromApi
    : Math.max(1, Math.ceil(sortedBdcList.length / pageSize));

  const handleDeleteBdc = async (bdcId) => {
    try {
      await instance.delete(`/bdc/delete/${bdcId}`);
      setOpened(false);
      toast.success("Bon de commande supprimé.", {
        position: toast.POSITION.TOP_CENTER,
        className: "toast-message",
      });

      setUserBdcList((prev) => prev.filter((bdc) => bdc.id !== bdcId));
    } catch (error) {
      toast.error("Error !", {
        position: toast.POSITION.TOP_LEFT,
      });
      console.log("error :>> ", error);
    }
  };

  const optionsStatus = [
    { value: "", label: "Tous les statuts", name: "" },
    { value: "TA", label: "Totalement Attribué", name: "TA" },
    { value: "NA", label: "Non Attribué", name: "NA" },
    { value: "PA", label: "Partiellement Attribué", name: "PA" },
  ];

  const afficherBouton =
    authState.email === "benoit@yuriandneil.com" ||
    authState.email === "christophe@yuriandneil.com" ||
    authState.email === "clement@yuriandneil.com" ||
    authState.email === "massinissa@yuriandneil.com" ||
    process.env.NODE_ENV === "development";

  const getStatusLabel = (element) => {
    if (element.totalAttribution === 0) {
      return "Non attribué";
    }
    if (element.totalAttribution === 100) {
      return "Attribué";
    }
    return `Attribué à ${element.totalAttribution}%`;
  };

  const exportToCsv = () => {
    const filteredBdcListForExport = displayedBdcRows.map((element) => ({
      "Numéro affaire": element.number,
      Client: element.client_name,
      Nom: element.name,
      Expertise: element.main_expertise,
      "Montant ttc": element.amount_ttc,
      "Date de début": element.start_date,
      "Date de fin": element.end_date,
      "Marge estimée ": element.estimated_amount,
      status: getStatusLabel(element),
    }));

    const csv = Papa.unparse(filteredBdcListForExport, {
      header: true,
      skipEmptyLines: true,
    });

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

    const link = document.createElement("a");
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "filtered_bdcs.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const rows = displayedBdcRows.map((element) => {
    const bdcId = element.id;
    const startDate = moment(element.start_date, "YYYY-MM").format("MM-YYYY");
    const endDate = moment(element.end_date).format("MM-YYYY");

    let status = "";
    let statusClass = "";

    if (element.totalAttribution === 0) {
      status = "Non attribué";
      statusClass = "status-non-attribue";
    } else if (element.totalAttribution === 100) {
      status = "Attribué";
      statusClass = "status-attribue";
    } else {
      status = "Attribué à " + element.totalAttribution + "%";
      statusClass = "status-partiellement-attribue";
    }

    return (
      <tr
        key={element.id}
        onClick={(event) => {
          const cmdOrCtrlPressed = event.metaKey || event.ctrlKey;
          if (!cmdOrCtrlPressed) {
            navigate(`/bdc/update/${bdcId}`);
          }
          handleRightClick(event, bdcId);
        }}
      >
        <td>{element?.number ?? 0}</td>
        <td
          style={{
            maxWidth: "200px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {element?.client_name}
        </td>
        <td
          style={{
            maxWidth: "300px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
          title={element?.name}
        >
          {element?.name ? `${element.name.substring(0, 18)}...` : ""}
        </td>
        <td>{element?.main_expertise ? element.main_expertise : ""}</td>
        <td>{element?.amount_ttc?.toLocaleString() ?? 0}€</td>
        <td>{startDate}</td>
        <td>{endDate}</td>
        <td>{element?.estimated_amount?.toLocaleString() ?? 0}€</td>
        <td>
          <div className={statusClass}>{status}</div>
        </td>

        <td>
          <img className="icon-action" src={edit} alt="edit" />

          <img
            className="icon-action"
            src={trash}
            alt="delete"
            onClick={() => {
              setOpened(true);
              setIdBdc(bdcId);
            }}
          />
        </td>
      </tr>
    );
  });

  return (
    <div className="bdc-page">
      <header>
        <h1>Liste des bons de commande</h1>
      </header>
      <NavBdc />
      <section>
        <Modal
          opened={opened}
          onClose={() => setOpened(false)}
          overlayOpacity={0.55}
          overlayBlur={3}
          transition="fade"
          transitionDuration={600}
          transitionTimingFunction="ease"
          size={650}
          padding={50}
        >
          <div className="container-confirm-delete">
            <div className="confirm-msg-delete">
              <p> Etes-vous sûr de vouloir supprimer cette affaire ?</p>
              <span>
                Vous ne pourrez plus revenir en arrière. Le bon de commande sera
                définitivement supprimer ainsi que toutes ses attributions
              </span>
            </div>
            <div className="div-button-choice">
              <button className="btn-no" onClick={() => setOpened(false)}>
                Annuler
              </button>
              <button className="btn-yes" onClick={() => handleDeleteBdc(idBdc)}>
                Supprimer
              </button>
            </div>
          </div>
        </Modal>
        <div className="import-search-div">
          <div className="search-create">
            {userBdcList.length !== 0 ? (
              <div>
                <input
                  className="search-bar"
                  type="text"
                  placeholder="Recheche bon de commande"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
            ) : (
              ""
            )}

            <div style={{ display: "flex", alignItems: "center" }}>
              <div className="status-filter">
                <Select
                  w={200}
                  style={{ cursor: "pointer", marginRight: " 12px" }}
                  placeholder="Filtrer par expertise"
                  color="gray.0"
                  id="statusFilter"
                  data={optionsType}
                  onChange={setTypeFilter}
                />
              </div>
              <div className="status-filter">
                <Select
                  w={200}
                  style={{ cursor: "pointer", marginRight: " 12px" }}
                  placeholder="Filtrer par statuts"
                  color="gray.0"
                  id="statusFilter"
                  data={optionsStatus}
                  onChange={setStatutFilter}
                />
              </div>
              <div>
                {userBdcList.length !== 0 && (
                  <button
                    className="btn-import-bdc"
                    style={{ cursor: "pointer", marginRight: "12px" }}
                    onClick={exportToCsv}
                  >
                    Exporter en CSV
                  </button>
                )}
              </div>
              {afficherBouton && (
                <button
                  disabled
                  className="btn-import-bdc"
                  style={{
                    cursor: "pointer",
                    marginRight: "12px",
                    backgroundColor: "gray",
                  }}
                  onClick={() => {
                    navigate(`/bdc/importAttribution`);
                  }}
                >
                  Importer Attribution
                </button>
              )}
              <button
                disabled
                className="btn-import-bdc"
                style={{ cursor: "pointer", backgroundColor: "gray" }}
                onClick={() => {
                  navigate(`/bdc/importBDC`);
                }}
              >
                Importer BDC
              </button>
            </div>
          </div>
        </div>
        {loading ? (
          <LoaderComp />
        ) : (
          <div className="container-table">
            {userBdcList.length > 0 ? (
              <table className="table">
                <thead className="thead-bdcs sticky-table-head">
                  <tr>
                    <th
                      className="th"
                      onClick={() => {
                        const newSortDirection =
                          sortDirection === "asc" ? "desc" : "asc";
                        setSortDirection(newSortDirection);
                        setFiltres({
                          ...filtres,
                          sortColumn: "number",
                          sortDirection: newSortDirection,
                        });
                      }}
                    >
                      Numéro affaire{" "}
                      <span>{sortDirection === "asc" ? " ↓" : " ↑"}</span>
                    </th>
                    <th
                      className="th"
                      onClick={() => {
                        const newSortDirection =
                          sortDirection === "asc" ? "desc" : "asc";
                        setSortDirection(newSortDirection);
                        setFiltres({
                          ...filtres,
                          sortColumn: "client_name",
                          sortDirection: newSortDirection,
                        });
                      }}
                    >
                      Client <span>{sortDirection === "asc" ? " ↓" : " ↑"}</span>
                    </th>
                    <th
                      className="th"
                      onClick={() => {
                        const newSortDirection =
                          sortDirection === "asc" ? "desc" : "asc";
                        setSortDirection(newSortDirection);
                        setFiltres({
                          ...filtres,
                          sortColumn: "name",
                          sortDirection: newSortDirection,
                        });
                      }}
                    >
                      Nom <span>{sortDirection === "asc" ? " ↓" : " ↑"}</span>
                    </th>
                    <th>Expertise</th>
                    <th
                      className="th"
                      onClick={() => {
                        const newSortDirection =
                          sortDirection === "asc" ? "desc" : "asc";
                        setSortDirection(newSortDirection);
                        setFiltres({
                          ...filtres,
                          sortColumn: "amount_ttc",
                          sortDirection: newSortDirection,
                        });
                      }}
                    >
                      Montant TTC{" "}
                      <span>{sortDirection === "asc" ? " ↓" : " ↑"}</span>
                    </th>
                    <th
                      className="th"
                      onClick={() => {
                        const newSortDirection =
                          sortDirection === "asc" ? "desc" : "asc";
                        setSortDirection(newSortDirection);
                        setFiltres({
                          ...filtres,
                          sortColumn: "start_date",
                          sortDirection: newSortDirection,
                        });
                      }}
                    >
                      Date de début{" "}
                      <span>{sortDirection === "asc" ? " ↓" : " ↑"}</span>
                    </th>
                    <th
                      className="th"
                      onClick={() => {
                        const newSortDirection =
                          sortDirection === "asc" ? "desc" : "asc";
                        setSortDirection(newSortDirection);
                        setFiltres({
                          ...filtres,
                          sortColumn: "end_date",
                          sortDirection: newSortDirection,
                        });
                      }}
                    >
                      Date de fin <span>{sortDirection === "asc" ? " ↓" : " ↑"}</span>
                    </th>
                    <th
                      className="th"
                      onClick={() => {
                        const newSortDirection =
                          sortDirection === "asc" ? "desc" : "asc";
                        setSortDirection(newSortDirection);
                        setFiltres({
                          ...filtres,
                          sortColumn: "estimated_amount",
                          sortDirection: newSortDirection,
                        });
                      }}
                    >
                      Marge estimée{" "}
                      <span>{sortDirection === "asc" ? " ↓" : " ↑"}</span>
                    </th>
                    <th>Statut</th>
                  </tr>
                </thead>
                <tbody>{rows}</tbody>
              </table>
            ) : (
              <p>Vous n'avez pas encore enregistré de bon de commandes</p>
            )}
            {totalPages > 1 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: "1rem",
                }}
              >
                <span>
                  Page {page} / {totalPages} | {totalRows} résultats
                </span>
                <div>
                  <button
                    className="btn-import-bdc"
                    style={{ marginRight: "8px" }}
                    disabled={page <= 1}
                    onClick={() => setPage((prev) => Math.max(1, prev - 1))}
                  >
                    Précédent
                  </button>
                  <button
                    className="btn-import-bdc"
                    disabled={page >= totalPages}
                    onClick={() =>
                      setPage((prev) => Math.min(totalPages, prev + 1))
                    }
                  >
                    Suivant
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
        {isVisible && (
          <button className="scroll-to-top" onClick={scrollToTop}>
            ↑
          </button>
        )}
      </section>
    </div>
  );
};

export default FixBdc;
